import {Component, OnInit, ViewChild} from '@angular/core';
import {BreadcrumbParent} from "../../../../shared/breadcrumb/breadcrumb/breadcrumb.component";
import {TranslateService} from "@ngx-translate/core";
import {StateName} from "../../../../app.state-names";
import {Set} from "immutable";
import {Task, TaskService} from "../../../../lib/task/task.service";
import {GrantedPermissionSetResolver, RightResolver, RightService} from "../../../../lib/right.service";
import {Transition} from "@uirouter/angular";
import {TaskRecord} from "../../../../lib/task/task-record.service";
import {TranslateUtils} from "../../../../util/translate";
import {RightModel} from "../../../../app.rights";
import {DqlSearchContainerComponent} from "../../../dql-search/dql-search-container/dql-search-container.component";
import {TaskRecordDqlFieldTextProvider} from "../../../../lib/task/task-record.dql.service";
import {Angular2Multiselects} from "../../../../util/multiselect";
import {MultiselectOptionItem} from "../../../../util/core-utils";
import {
  TaskCustomStatisticsMultiselectProvider
} from "../../../../lib/task/custom-statistics/task-custom-statistics-multiselect-provider.service";
import {
  TaskRecordCustomStatisticsDiagramModel,
  TaskRecordCustomStatisticsModel
} from "./task-record-custom-statistics.model";
import {TaskCustomStatisticsService} from "../../../../lib/task/custom-statistics/task-custom-statistics.service";
import {OperationRights} from "../../../../app.right-definitions";
import {CustomStatisticsRightModel} from "../../../../lib/custom-statistics/custom-statistics-right.model";
import {MatDialog} from "@angular/material/dialog";
import {Form} from "../../../../lib/form/form.service";
import {
  TaskRecordCustomStatisticsSaveDialogComponent
} from "./task-record-custom-statistics-save-dialog/task-record-custom-statistics-save-dialog.component";
import {
  TaskRecordCustomStatisticsDiagramDialogComponent
} from "./task-record-custom-statistics-diagram-dialog/task-record-custom-statistics-diagram-dialog.component";
import {CustomStatistics} from "../../../../lib/custom-statistics/custom-statistics";
import {GoogleChartInterface} from "ng2-google-charts/google-charts-interfaces";
import DiagramVisualType = CustomStatistics.DiagramVisualType;

@Component({
  selector: 'app-task-record-custom-statistics',
  templateUrl: './task-record-custom-statistics.component.html',
  styleUrls: ['./task-record-custom-statistics.component.scss']
})
export class TaskRecordCustomStatisticsComponent implements OnInit {

  breadcrumbSelf: string;
  breadcrumbParents: BreadcrumbParent[] = [];
  compactSidebar: boolean = document.querySelector('body')!.classList.contains('sidebar-compact');
  readonly taskId: number;
  task: Task.Task;
  taskManagedFields: Set<TaskRecord.TaskRecordField> = Set.of();
  rightModel: RightModel = RightModel.empty();
  firstLoad: boolean = true;

  dropdownSettingsForSingle: Angular2Multiselects.Settings = Angular2Multiselects.REMOTE_SINGLE_SELECT;
  statistics: MultiselectOptionItem<number>[] = [];
  _selectedStatistics: MultiselectOptionItem<number>[] = [];
  model: TaskRecordCustomStatisticsModel = new TaskRecordCustomStatisticsModel();

  get selectedStatistics(): MultiselectOptionItem<number> | undefined {
    return this._selectedStatistics.length > 0 ? this._selectedStatistics[0] : undefined;
  }

  private dqlSearchContainer?: DqlSearchContainerComponent;

  @ViewChild('dqlSearchContainer') set dqlContainer(c: DqlSearchContainerComponent) {
    if (c) {
      if (!this.dqlSearchContainer) {
        this.dqlSearchContainer = c;
        this.loadDqlModel(() => {
          this.loadDqlSearch(this.model.selectedStatistics?.dqlFilter);
          this.dqlSearchContainer!.loadContent();
        });
      }
    } else {
      this.dqlSearchContainer = undefined;
    }
  }

  displayedDiagrams: ChartData[] = [];

  constructor(private transition: Transition,
              private rightService: RightService,
              private taskService: TaskService,
              private translateService: TranslateService,
              private taskCustomStatisticsMultiselectProvider: TaskCustomStatisticsMultiselectProvider,
              private taskCustomStatisticsService: TaskCustomStatisticsService,
              private dialog: MatDialog) {
    this.taskId = this.transition.params().taskId!;

  }

  ngOnInit(): void {
    this.loadRightModels();
    this.translateService.get(['MENU_NAVBAR_FORMS', 'TASK_RECORD_CUSTOM_STATISTICS']).subscribe(
      (result) => {
        this.breadcrumbParents.unshift({
          name: TranslateUtils.extractValueFromObject(result, 'MENU_NAVBAR_FORMS'),
          uiSref: StateName.TASK_DASHBOARD
        });
        this.breadcrumbSelf = TranslateUtils.extractValueFromObject(result, 'TASK_RECORD_CUSTOM_STATISTICS');
        this.taskService.get({
          taskId: this.taskId
        }).subscribe(
          (result: Task.Task) => {
            this.task = result;
            this.breadcrumbParents.push({
              name: result.name,
              uiSref: StateName.TASK_RECORD_LIST,
              uiParam: {taskId: this.taskId}
            });
            this.taskManagedFields = result.managedFields;
          }
        );
      }
    );
  }

  private loadRightModels() {
    this.rightService.getRightResolver().subscribe(
      (resolver: RightResolver) => {
        this.rightModel = RightModel.of(resolver);
      }
    );
  }

  onDqlSearchClicked() {
    this.displayedDiagrams = [];
    const dqlQueryString = this.dqlSearchContainer!.getQueryString();
    if (dqlQueryString) {
      this.taskCustomStatisticsService.getResults({
        taskId: this.taskId,
        id: this.model.selectedStatisticsId!,
        dql: dqlQueryString
      }).subscribe(result => {
        result.diagrams.forEach(diagram => {
          const diagramDataTable: any[] = [];
          const diagramFirstRow: any[] = [];
          diagramFirstRow.push('Value');
          diagramFirstRow.push('Count');
          diagramDataTable.push(diagramFirstRow);
          for (const key in diagram.stats) {
            const row: any[] = [];
            row.push(key);
            row.push(diagram.stats[key]);
            diagramDataTable.push(row);
          }
          const chartType = diagram.visualType === DiagramVisualType.PIE_CHART ? 'PieChart' : 'PieChart';
          this.displayedDiagrams.push({
            name: diagram.name,
            chartData: {
              chartType: chartType,
              dataTable: diagramDataTable,
              options: {
                'is3D': false,
                'pieSliceText': 'value',
                'height': '300',
                'chartArea': {'height': '100%', 'width': '100%'}
              }
            }
          });
        })
      });
    }
  }

  loadDqlModel(completion?: () => void) {
    this.dqlSearchContainer!.setFields(this.taskService.getDqlModel({taskId: this.taskId}),
      TaskRecordDqlFieldTextProvider.getHelper(),
      completion ? completion : () => {
      });
  }

  loadDqlSearch(queryString?: string) {
    if (queryString) {
      this.dqlSearchContainer!.loadQuery(queryString);
    }
  }

  loadCustomStatistics(q?: string) {
    this.taskCustomStatisticsMultiselectProvider.loadAll(this.taskId, q).subscribe(stats => {
      this.statistics = stats;
      if (!this.rightModel.customStatisticsCreate.hasRight() && this._selectedStatistics.length === 0 && this.firstLoad && stats.length > 0) {
        this._selectedStatistics = [stats[0]];
        this.statSelected(stats[0]);
      }
      this.firstLoad = false;
    });
  }

  statSelected(stat?: MultiselectOptionItem<number>) {
    this.displayedDiagrams = [];
    this.model.reset();
    if (stat) {
      this.taskCustomStatisticsService.get({
        taskId: this.taskId,
        id: stat.id,
        fields: f => f.each,
        rights: Set.of(OperationRights.CUSTOM_STATISTICS_DELETE, OperationRights.CUSTOM_STATISTICS_UPDATE)
      }).subscribe(stat => {
        this.model.selectedStatistics = stat;
        this.model.grantedRights = new CustomStatisticsRightModel(GrantedPermissionSetResolver.byGrantedRights(stat.grantedRights!));
        this.model.name = stat.name!;
        this.model.externalId = stat.externalId!;
        this.model.diagramModels = stat.diagrams!.map(d => {
          return {name: d.formFieldData.formField.title, formFieldId: d.formFieldData.formField.fieldId}
        });
      })
    }
  }

  onCreateClicked() {
    this.model.createNew = true;
    this.displayedDiagrams = [];
  }

  onUpdateClicked() {
    this.model.updateInProgress = true;
    this.displayedDiagrams = [];
  }

  onDeleteClicked() {
    const index = this.statistics.findIndex(s => s.id === this.model.selectedStatisticsId);
    if (index >= 0) {
      this.statistics.splice(index, 1);
    }
    this.displayedDiagrams = [];
    this.taskCustomStatisticsService.delete({taskId: this.taskId, id: this.model.selectedStatisticsId!})
      .subscribe(res => {
        this.model.reset();
        this._selectedStatistics = [];
      })
  }

  get canSave(): boolean {
    return this.model.editingInProgress && this.model.diagramModels.length > 0
      && this.isDqlValid();
  }

  isDqlValid(): boolean {
    return this.dqlSearchContainer?.getQueryString() !== undefined;
  }

  onSaveClicked() {
    const query = this.dqlSearchContainer?.getQueryString();
    if (query && this.model.diagramModels.length > 0) {
      this.model.query = query;
      TaskRecordCustomStatisticsSaveDialogComponent.openDialog(this.dialog, {
        model: this.model,
        taskId: this.taskId
      }, (result) => {
        if (result?.success) {
          this.model.resetToSelected();
          const item = {id: result.statId!, itemName: this.model.name, itemSubtitle: this.model.externalId};
          this._selectedStatistics = [item];
          const index = this.statistics.findIndex(v => v.id === item.id);
          if (index < 0) {
            this.statistics.push(item);
          } else {
            this.statistics.splice(index, 1);
            this.statistics.push(item);
          }
          this.statSelected(item);
        }
      })
    }
  }

  onCancelClicked() {
    this.model.resetToSelected();
  }

  onNewDiagramClicked() {
    if (this.task.form) {
      const fields: Form.Field[] = this.task.form!.groups.flatMap((g, key) => g!.fields).toArray();
      TaskRecordCustomStatisticsDiagramDialogComponent.openDialog(this.dialog, {formFields: fields}, result => {
        if (result?.success) {
          const diagram = new TaskRecordCustomStatisticsDiagramModel();
          diagram.formFieldId = result.fieldId!;
          diagram.name = fields.find(f => f.fieldId === diagram.formFieldId)!.title;
          this.model.diagramModels.push(diagram);
        }
      });
    }
  }

  modifyDiagramClicked(diagram: TaskRecordCustomStatisticsDiagramModel) {
    if (this.task.form && diagram) {
      const fields: Form.Field[] = this.task.form!.groups.flatMap((g, key) => g!.fields).toArray();
      TaskRecordCustomStatisticsDiagramDialogComponent.openDialog(this.dialog, {
        formFields: fields,
        selectedFieldId: diagram.formFieldId
      }, result => {
        if (result?.success) {
          diagram.formFieldId = result.fieldId!;
          diagram.name = fields.find(f => f.fieldId === diagram.formFieldId)!.title;
        }
      });
    }
  }

  deleteDiagramClicked(diagramIndex: number) {
    this.model.diagramModels.splice(diagramIndex, 1);
  }

  addDiagramDisabled() {
    return this.model.diagramModels.length >= 6;
  }
}

interface ChartData {
  name: string;
  chartData: GoogleChartInterface;
}
